import { UserType } from '@inplay/models';
import { OrgUnitPresentation } from './orgUnitPresentation.interface';
import { SubOrganizationPresentationStrategy } from './implementations/subOrganizationPresentationStrategy';
import { VenuePresentationStrategy } from './implementations/venuePresentationStrategy';
import {
  Organization,
  SubOrganization,
  Venue,
  VenueBranch,
} from '../../utils/helper.type';
import { OrganisationToggleEnum } from '../../pages/userManagement/userManagement.type';
import { OrganizationPresentationStrategy } from './implementations/organizationPresentationStrategy';
import { VenueBranchPresentationStrategy } from './implementations/venueBranchPresentationStrategy';

export class OrgUnitPresentationFactory {
  static getPresentationStrategy(
    viewerType: UserType,
    selectedToggle: OrganisationToggleEnum,
    nestedLevel: number,
  ):
    | OrgUnitPresentation<SubOrganization>
    | OrgUnitPresentation<Venue>
    | OrgUnitPresentation<Organization>
    | OrgUnitPresentation<VenueBranch> {
    if (viewerType === UserType.ORGANIZATION_ADMIN) {
      if (selectedToggle === OrganisationToggleEnum.ORGANISATION) {
        if (nestedLevel === 0) {
          return new OrganizationPresentationStrategy();
        } else {
          // nestedLevel > 1
          return new SubOrganizationPresentationStrategy();
        }
      } else {
        // Venues view selected
        if (nestedLevel === 0) {
          return new SubOrganizationPresentationStrategy();
        } else if (nestedLevel === 1) {
          return new VenuePresentationStrategy();
        } else {
          // nestedLevel > 1
          return new VenueBranchPresentationStrategy();
        }
      }
    } else if (viewerType === UserType.SUB_ORGANIZATION_ADMIN) {
      if (selectedToggle === OrganisationToggleEnum.ORGANISATION) {
        return new SubOrganizationPresentationStrategy();
      } else {
        // Venues view selected
        if (nestedLevel === 0) {
          return new VenuePresentationStrategy();
        } else {
          // nestedLevel > 0
          return new VenueBranchPresentationStrategy();
        }
      }
    } else {
      throw new Error(`No view strategy defined for user type: ${viewerType}`);
    }
  }
}
